module.exports = function () {
  return new Worker(__webpack_public_path__ + "5928717d2d7b178137a7.worker.js");
};